<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.reasons', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                    <b-form-group
                            id="reference-group"
                            :label="$t('message.reference')"
                            label-for="reference"
                            description=""
                    >
                        <b-form-input
                                id="reference"
                                v-model="$v.form.reference.$model"
                                :state="$v.form.reference.$dirty ? !(errorshasField('reference') || $v.form.reference.$error) : null"
                                required
                                placeholder=""
                                @focus="clearErrorField('reference')"
                        ></b-form-input>

                        <b-form-invalid-feedback v-if="!$v.form.reference.required">
                            {{ $t('message.requiredField') }}
                        </b-form-invalid-feedback>

                        <b-form-invalid-feedback v-else-if="errorshasField('reference')">
                            {{ getErrorsField('reference') }}
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group
                            id="description-group"
                            :label="$t('message.description')"
                            label-for="description">
                        <b-form-textarea
                                id="description"
                                v-model="$v.form.description.$model"
                                :state="$v.form.description.$dirty ? !(errorshasField('description') || $v.form.description.$error) : null"
                                rows="5"
                                required
                                placeholder=""
                                @focus="clearErrorField('description')"
                        ></b-form-textarea>

                        <b-form-invalid-feedback v-if="!$v.form.description.required">
                            {{ $t('message.requiredField') }}
                        </b-form-invalid-feedback>

                        <b-form-invalid-feedback v-else-if="errorshasField('description')">
                            {{ getErrorsField('description') }}
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-button type="submit" variant="primary">
                        {{ $t('message.save') }}
                    </b-button>

                    <b-button type="reset" variant="danger">
                        {{ $t('message.reset') }}
                    </b-button>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required } from 'vuelidate/lib/validators';

    export default {
        name: "AddReason",

        computed: {
            ...mapGetters(["errors",'hasAdminRole',
                'hasMedecinControleRole','hasAssistante',
                'hasPraticienRole']),

            can:function(){
                return this.hasAdminRole || this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
            },
        },

        data() {
            return {
                hospitalisation_id: this.$route.params.hospitalisation,
                form: {
                    description: '',
                    reference: '',
                },
                show: true
            }
        },

        methods: {
            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        hospitalisation: this.hospitalisation_id,
                        description: this.form.description,
                        reference: this.form.reference,
                    };

                    let successMessage = this.$i18n.t('message.reasonCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createHospitalisationReason', { args, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
            },

            onReset: function(evt) {
                evt.preventDefault();

                // Reset our form values
                this.form.description = '';
                this.form.reference = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                description: {
                    required
                },

                reference: {
                    //
                }
            }
        }
    }
</script>

<style scoped>

</style>